<template>
  <div class="container">
    <div class="overviewAndNav mb-1">
      <h3>Overzicht klanten</h3>
      <span>
        <select class="form-select" v-model="customerFiltering">
          <option :key="mode" v-for="mode in getFilterModes()">{{ mode }}</option>
        </select>
        <button v-if="!showCreateCustomer" class="btn-basic btn-fill-pulse" @click="toggleCreateCustomer">Nieuw</button>
        <button v-else class="btn-basic btn-fill-pulse-dark" @click="toggleCreateCustomer">Annuleren</button>
      </span>
    </div>
    <div class="row my-2">
          <input
              ref="focusMe"
              type="text"
              class="form-control"
              placeholder="Zoeken op naam .."
              v-model="search"/>
    </div>
    <div class="row" v-show="showCreateCustomer">
      <CreateCustomerComponent id="createCustomer" @customerAdded="toggleCreateCustomer"/>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="id" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Klant id"/>
            <SortableTableHeaderComponent
                columnName="name" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Naam klant"/>
            <SortableTableHeaderComponent
                columnName="abbreviation" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Afkorting"/>
            <SortableTableHeaderComponent
                columnName="activeContractCount" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Aantal actieve contracten"/>
            <SortableTableHeaderComponent
                columnName="futureContractCount" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Aantal toekomstige contracten"/>
            <th scope="col">Actie</th>
          </tr>
          </thead>
          <template v-for="customer in sortedCustomers">
            <tr :key="customer.id">
              <td>{{ customer.id }}</td>
              <td>{{ customer.name }}</td>
              <td>{{ customer.abbreviation }}</td>
              <td>{{ customer.activeContractCount }}</td>
              <td>{{ customer.futureContractCount }}</td>
              <td>
                <button class="btn-basic btn-outline-pulse" @click="showDetailed(customer)">Meer details</button>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import CreateCustomerComponent from "@/Admin/CreateCustomerComponent/CreateCustomerComponent";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";
import FilterModes, {ActivityStatusList} from "@/constants/FilterConstants";

export default {
  name: "AdminCustomerComponent",
  components: {
    SortableTableHeaderComponent,
    CreateCustomerComponent,
  },
  data: () => ({
    showCreateCustomer: false,
    currentSortColumn: "id",
    currentSortDirectionAscending: true,
    search: '',
    customerFiltering: FilterModes.ACTIVE,
  }),
  computed: {
    ...mapGetters({
      customers: "administrationCustomer/customers"
    }),
    sortedCustomers: function () {
      let sortedList = sortListByColumnAndDirection(this.filterCustomers(), this.currentSortColumn, this.currentSortDirectionAscending);
      return sortedList.filter(customer => {
        return customer.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  mounted() {
    this.$refs.focusMe.focus();
  },
  async created() {
    await this.fetchCustomers();
  },
  methods: {
    ...mapActions("administrationCustomer", ["fetchCustomers"]),
    ...mapMutations({
      setSelectedCustomer: "administrationCustomer/setSelectedCustomer",
      setSelectedCustomerDetail: "administrationCustomer/setSelectedCustomerDetail",
      setSelectedParentCompany: "administrationCustomer/setSelectedParentCompany",
      setSelectedSubdivisions: "administrationCustomer/setSelectedSubdivisions",
      setAvailableSubdivisions: "administrationCustomer/setAvailableSubdivisions",
    }),
    showDetailed: function (customer) {
      this.setSelectedCustomer(customer);
      this.setSelectedCustomerDetail(customer);
      this.setParentCompany(customer);
      this.setSelectedSubdivisions(customer);
      this.setAvailableSubdivisions(customer);

      this.$router.push({path: "/admin/viewCustomerDetail"});
    },
    setParentCompany(customer) {
      if (customer.parentCompanyId > 0) {
        let parentCompany = this.customers.filter(parent => parent.id === customer.parentCompanyId);
        this.setSelectedParentCompany(parentCompany[0]);
      }
      else {
        this.setSelectedParentCompany(null);
      }
    },
    toggleCreateCustomer() {
      this.showCreateCustomer = !this.showCreateCustomer;
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    },
    getFilterModes() {
      return ActivityStatusList;
    },
    filterCustomers() {
      if (this.customerFiltering === FilterModes.ACTIVE) {
        return this.customers.filter(customer => customer.active);
      }
      if (this.customerFiltering === FilterModes.NOT_ACTIVE) {
        return this.customers.filter(customer => !customer.active);
      }
      return this.customers;
    },
  },
};
</script>

<style scoped>

td {
  vertical-align: middle;
}

.overviewAndNav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
